import { createContext } from 'react';
import type { WorkspaceWorkspaceReadModel } from '@r/api/generated/client.schemas.ts';

type Workspace = WorkspaceWorkspaceReadModel;

type WorkspaceContextType = {
  workspace: Workspace | undefined;
  isWorkspacePending: boolean;
  isWorkspaceError: boolean;
  isWorkspaceSuccess: boolean;
};

const WorkspaceContext = createContext<WorkspaceContextType>({
  workspace: undefined,
  isWorkspacePending: false,
  isWorkspaceError: false,
  isWorkspaceSuccess: false
});

export { WorkspaceContext };
